import keyMirror from "keymirror";

export default keyMirror({
  HOME: null,
  GENERAL: null,
  GREETING_BOT: null,
  NOTIFICATIONS: null,
  EVENTS: null,
  LEADS: null,
  COMPLETED_MEETINGS: null,
});
